import { TEntityOverride } from 'src/types'

const override: TEntityOverride = {
  global: {
    properties: {
      groups: {
        type: 'groups',
      },
    },
  },
  edit: {
    properties: {
      groups: {
        type: 'groups',
      },
    },
  },
}

export default override
